import styled from 'styled-components';

// import HockeyFieldBnw from './images/HockeyFieldBnw.svg';
import bgCom from '../../assets/images atp/bgtopSection.png';
// import bgComDesk from '../../assets/images atp/Frame.png';

type ConteinerPros = {
  isCongratsPopupOpen?: any;
};
export const Container = styled('div')<ConteinerPros>((props) => ({
  backgroundSize: 'cover',
  filter: props.isCongratsPopupOpen ? 'blur(4px)' : 'unset',
  color: 'white',
  textAlign: 'center',
  WebkitTouchCallout: 'none',
  '@media screen and (min-width: 1100px)': {
    width: '100%',
    maxWidth: '1440px',
    margin: 'auto',
    // backgroundColor: '#003366',
    borderRadius: '0px 0px 24px 24px',
  },
}));

export const StyledButton = styled('button')({
  borderRadius: '8px',
  height: '50px',
  width: '100%',
  color: '#ffffff',
  padding: '15px 0',
  fontWeight: '700',
  fontSize: '18px',
  lineHeight: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#ED1A38',
  border: 'none',
  cursor: 'pointer',
  marginTop: '18px',
  '@media screen and (min-width: 1250px)': {
    width: '200px',
  },
  '& div': {
    display: 'flex',
    top: 'unset',
    marginTop: '0',
  },
});
export const StyledButtonConf = styled('button')({
  borderRadius: '8px',
  fontFamily: 'RocGrotesk',
  height: '40px',
  width: '155.5px',
  color: '#051224',
  padding: '15px 0',
  fontWeight: '700',
  fontSize: '12px',
  lineHeight: '16.8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#E4F53B',
  border: 'none',
  cursor: 'pointer',
  '& div': {
    display: 'flex',
    top: 'unset',
    marginTop: '0',
  },
  '@media screen and (min-width: 1100px)': {
    maxWidth: '192px',
    margin: 'auto',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '18px',
    height: '54px',
  },
});

export const StyledShareButton = styled(StyledButton)({
  backgroundColor: '#E4F53B',
  color: '#051224',
});

export const ShutoutTopContainer = styled('div')({});

export const ThreeGoaliesContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '0px 8px 20px 8px',
  gap: '8px',
  justifyContent: 'space-around',
  '@media screen and (min-width: 1100px)': {
    paddingBottom: '99px',
    backgroundColor: '#036',
    margin: 0,
    gap: '10px',
  },
});

export const DragDropField = styled('div')({
  textAlign: 'center',
  '@media screen and (min-width: 1100px)': {
    marginTop: '0px',
    position: 'relative',
  },
});

export const CanContainer = styled('div')({
  // width: 'min-content',
  // margin: '0vh auto 0px -14px',
  // paddingBottom: "60px",
  '@media screen and (min-width: 1100px)': {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    position: 'relative',
  },
});

export const CanDescriptionContainer = styled('div')({
  background: 'black',
  width: '100%',
  height: '171px',
  paddingTop: '56px',
  borderTop: '3px solid #E4F53B',
  zIndex: 2,
  '@media screen and (min-width: 1100px)': {
    width: '100vw',
    paddingTop: '155px',
    height: '361px',
    margin: '0',
    borderTop: '3px solid #E4F53B',
  },
});

export const UnderGoalieSpan = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textTransform: 'uppercase',
  marginTop: '8px',
  fontSize: '10px',
  fontWeight: 700,
  lineHeight: '14px',
  '& svg': {
    width: '60%',
  },
  '@media screen and (min-width: 1250px)': {
    fontSize: '24px',
  },
});
export const ScoringSpan = styled('div')({
  textTransform: 'uppercase',
  marginTop: '12px',
  fontSize: '24px',
  // color: '#0CD664',
  fontWeight: 700,
  lineHeight: '31.2px',
  '@media screen and (min-width: 1250px)': {
    fontSize: '30px',
  },
});

export const PepsiCanContainer = styled('div')({
  zIndex: 3,
  minWidth: '80px',
  minHeight: '100px',
  position: 'relative',
  '& img': {
    margin: '0 auto',
    position: 'relative',
    // right: '116px',
    top: '54px',
    maxWidth: '120px',
    height: '120px',
    // maxWidth: '90px',
    '@media screen and (min-width: 1100px)': {
      maxWidth: '200px',
      height: '200px',
      margin: '0 auto',
      position: 'absolute',
      right: '-79px',
      top: '-24px',
    },
  },
});

export const Button = styled('button')({
  // to /scores & video ad
  background: '#E4F53B',
  border: 'none',
  width: '50vw',
  padding: '26px 12px',
  fontWeight: 400,
  fontSize: '16px',
  color: 'black !important',
  textTransform: 'none',
});

export const EmptyPepsiCanContainer = styled('div')({
  height: '90px',
  zIndex: 3,
  position: 'relative',
  WebkitTouchCallout: 'none',
  '& img': {
    margin: '0 auto',
    position: 'relative',
    // right: '116px',
    top: '54px',
    maxWidth: '120px',
    height: '120px',
    WebkitTouchCallout: 'none',
    '@media screen and (min-width: 1100px)': {
      maxWidth: '262px',
      height: '262px',
      margin: '0 auto',
      position: 'absolute',
      right: '-79px',
      top: '-24px',
    },
  },
});
export const StyledButtonRed = styled('button')({
  borderRadius: '8px',
  maxWidth: '200px',
  height: '50px',
  width: '100%',
  color: '#ffffff',
  fontWeight: '700',
  fontSize: '18px',
  lineHeight: '18px',
  margin: 'auto',
  padding: '15px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#ED1A38',
  border: 'none',
  cursor: 'pointer',
  marginTop: '18px',
  '& div': {
    display: 'flex',
    top: 'unset',
    marginTop: '0',
  },
});
export const StyledButtonShare = styled('button')({
  maxWidth: '250px',
  height: '50px',
  width: '100%',
  color: '#ffffff',
  margin: 'auto',
  padding: '15px 0',
  fontWeight: '700',
  fontSize: '18px',
  lineHeight: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  marginTop: '18px',
  '& div': {
    display: 'flex',
    top: 'unset',
    marginTop: '0',
  },
});

export const PlayersContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  minWidth: '106px',
  maxWidth: '106px',
  height: '110px',
  '@media screen and (min-width: 1100px)': {
    minWidth: '150px',
    maxWidth: '243.11px',
    height: '262.18px',
    padding: '0px 0px',
  },
});

export const PlayerCardWrapper = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 auto',
  paddingTop: '0px',
  columnGap: '16px',
  rowGap: '16px',
  '@media screen and (min-width: 1100px)': {
    marginBottom: '48px',
    columnGap: '51px',
  },
});
export const WrapperCorner = styled('img')({
  width: '28px',
  height: '28px',
  '@media screen and (min-width: 1100px)': {
    width: '80px',
    height: '80px',
  },
});
export const WrapperTopBox = styled('div')({
  background: `url(${bgCom})`,
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  position: 'relative',
  padding: '24px 16px 24px 16px',
  flexDirection: 'column',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  '@media screen and (min-width:1100px)': {
    padding: '64px 16px',
    backgroundRepeat: 'no-repeat',
    // background: `url(${bgComDesk})`,
  },
});
